import React from 'react';
import { useSelector } from 'react-redux';
import { AgCharts } from 'ag-charts-react';
import 'ag-charts-enterprise';

const SalesChart = () => {
    const { hourlySales } = useSelector(state => state.reports || {});

    const renderer = (params) => {
        return (
            `<div class="ag-chart-tooltip-custom"><b class="title">${params.datum.time}:00</b><br/><b>Selected Day: ${params.datum.todaySales}</b><br/><b>Previous Day: ${params.datum.prevSales}</b></div>`
        );
    };

    const chartOptions = {
        data: hourlySales,
        series: [
            {
                type: "line",
                xKey: "time",
                yKey: "todaySales",
                yName: "Selected Date",
                interpolation: { type: "smooth" },
                tooltip: { renderer },
                stroke:   '#7a60e5',
                marker: {
                    enabled: true,            // Enable the markers (dots)
                    size: 5,                  // Set the size of the dot
                    shape: 'circle',          // Set the shape of the dot ('circle', 'square', etc.)
                    fill: '#f8f9fa',              // Dot color
                    stroke: '#7a60e5',          // Border color of the dot
                    strokeWidth: 1            // Border width of the dot
                },
            },
            {
                type: "line",
                xKey: "time",
                yKey: "prevSales",
                yName: "Previous Day",
                interpolation: { type: "smooth" },
                tooltip: { renderer },
                stroke:   '#616165',
                marker: {
                    enabled: true,            // Enable the markers (dots)
                    size: 5,                  // Set the size of the dot
                    shape: 'circle',          // Set the shape of the dot ('circle', 'square', etc.)
                    fill: '#f8f9fa',              // Dot color
                    stroke: '#616165',          // Border color of the dot
                    strokeWidth: 1            // Border width of the dot
                },
            }
        ],
        axes: [
          {
            type: 'time',  // X-axis is a category axis for the date
            position: 'bottom',
            label: {
                formatter: ({ value }) => `${(value % 24).toString()}:00`,
            },
            gridLine: {
                enabled: true,
            },
            interval: {
                step: 1,
                maxSpacing: 13,
            },
            
          },
          {
            type: 'number',
            position: 'left',
            keys: ["todaySales", "prevSales"],
            label: {
                formatter: ({ value }) => `$${value}`,
            },
            gridLine: {
                enabled: true,
              }
          },
        ],
        background: {
            fill: '#f8f9fa', // Set background color here
        },
    };
    return(
        <React.Fragment>
            <h3 className="m-0 text-center text-justify">Sales</h3>
            <div style={{ height: 450 }}>
                <AgCharts options={chartOptions} style={{ height: 450 }}/>
            </div>
        </React.Fragment>
    )
};
export default SalesChart;